
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Sheet, SheetContent, SheetTrigger } from "./ui/sheet";
import { Menu, X, LayoutGrid, Users, CheckSquare, MessageCircle, Activity, Settings, LogOut, MessageSquare } from "lucide-react";
import { useAuth } from "../contexts/AuthContext";
import { useState } from "react";
import { Avatar, AvatarFallback, AvatarImage } from "./ui/avatar";

const menuItems = [
  { title: "Dashboard", icon: LayoutGrid, url: "/app/dashboard" },
  { title: "Meetings", icon: Users, url: "/app/meetings" },
  { title: "Action Items", icon: CheckSquare, url: "/app/action-items" },
  { title: "Thoughts", icon: MessageCircle, url: "/app/thoughts" },
  { title: "Status", icon: Activity, url: "/app/status" },
];

export function MobileMenu() {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const { user, signOut } = useAuth();

  const handleSignOut = async () => {
    try {
      await signOut();
      setOpen(false);
    } catch (error) {
      console.error("Error signing out:", error);
    }
  };

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetTrigger asChild>
        <div className="md:hidden cursor-pointer p-2">
          <Menu className="h-5 w-5" />
          <span className="sr-only">Toggle menu</span>
        </div>
      </SheetTrigger>
      <SheetContent side="right" className="w-[85vw] sm:w-[350px] p-0">
        <div className="flex flex-col h-full">
          <div className="flex items-center justify-between p-4 border-b">
            <div className="flex items-center gap-2">
              <MessageSquare className="h-6 w-6" />
              <span className="font-semibold text-lg">MeetMemoize</span>
            </div>
            <X 
              className="h-5 w-5 cursor-pointer text-gray-500 hover:text-gray-700"
              onClick={() => setOpen(false)}
            />
          </div>

          <div className="flex-1 overflow-auto py-6">
            <nav className="space-y-1 px-4">
              {menuItems.map((item) => {
                const isActive = location.pathname === item.url;
                return (
                  <Link
                    key={item.title}
                    to={item.url}
                    onClick={() => setOpen(false)}
                    className={`flex items-center gap-3 px-4 py-2 rounded-lg text-sm transition-colors ${
                      isActive 
                        ? "bg-accent text-accent-foreground" 
                        : "text-muted-foreground hover:bg-accent/50 hover:text-accent-foreground"
                    }`}
                  >
                    <item.icon className="h-5 w-5" />
                    {item.title}
                  </Link>
                );
              })}
            </nav>
          </div>

          <div className="border-t p-4">
            <Link
              to="/app/settings/profile"
              onClick={() => setOpen(false)}
              className="flex items-center gap-3 mb-4"
            >
              <Avatar>
                <AvatarImage src={user?.user_metadata?.avatar_url} />
                <AvatarFallback>
                  {user?.user_metadata?.first_name?.[0]?.toUpperCase() || user?.email?.[0]?.toUpperCase()}
                </AvatarFallback>
              </Avatar>
              <div className="flex flex-col">
                <span className="text-sm font-medium">
                  {`${user?.user_metadata?.first_name || ''} ${user?.user_metadata?.last_name || ''}`}
                </span>
                <span className="text-xs text-muted-foreground">View profile</span>
              </div>
            </Link>

            <div className="space-y-1">
              <Link 
                to="/app/settings"
                onClick={() => setOpen(false)}
                className="flex items-center gap-2 w-full px-4 py-2 text-sm text-muted-foreground rounded-lg hover:bg-accent/50 hover:text-accent-foreground"
              >
                <Settings className="h-4 w-4" />
                Settings
              </Link>
              <button
                onClick={handleSignOut}
                className="flex items-center gap-2 w-full px-4 py-2 text-sm text-red-600 rounded-lg hover:bg-red-50"
              >
                <LogOut className="h-4 w-4" />
                Sign out
              </button>
            </div>
          </div>
        </div>
      </SheetContent>
    </Sheet>
  );
}